import {AsyncDataLoading} from '@frontend/components/AsyncDataLoading'
import type {
    AdsListPresentation,
    FilteredItemsListPageHeaderInfo,
    FilteredItemsPageUrlQueryParams,
    ItemsListRouteParams,
} from '@frontend/modules/public/ads/AdsModuleTypes'
import {useFilteredItemsLoader} from '@frontend/modules/public/ads/hooks/useFilteredItemsLoader'
import {ServicesFromOtherLocations} from '@frontend/modules/public/services/components/list/ServicesFromOtherLocations'
import {ServicesList} from '@frontend/modules/public/services/components/list/ServicesList'
import type {ExecutorPreviewData} from '@frontend/modules/public/services/ServicesModuleTypes'
import {useEffect} from 'react'
import {
    useLocation,
    useParams,
} from 'react-router-dom'
import {useUrlQueryParams} from 'swayok-react-mdb-ui-kit/helpers/useUrlQueryParams'
import {extractIdFromUrlSlug} from '../../../../../helpers/extractIdFromUrlSlug'

interface FilteredServicesListProps {
    // Количество услуг на странице:
    // Рекомендуемое количество: 5-10.
    pageLimit?: number
    adsPresentation?: AdsListPresentation
    setPageHeaderInfo: (header: FilteredItemsListPageHeaderInfo) => void
}

// Список отфильтрованных исполнителей услуг.
export function FilteredServicesList(props: FilteredServicesListProps) {

    const {
        adsPresentation = 'grid',
        pageLimit = 10,
        setPageHeaderInfo,
    } = props

    // Данные о текущем URL.
    const location = useLocation()
    const routeParams = useParams<ItemsListRouteParams>()
    const {
        urlQueryData,
    } = useUrlQueryParams<FilteredItemsPageUrlQueryParams>()

    const categoryId: number | null = extractIdFromUrlSlug(routeParams.slugWithId)

    const {
        loadItems,
        isLoading,
        items,
        totalItemsCount,
        loadingError,
        isAllItemsLoaded,
        onItemDataChange,
    } = useFilteredItemsLoader<ExecutorPreviewData>({
        type: 'services',
        listIdForAnalytics: 'search',
        pageLimit,
        categoryId,
        filters: urlQueryData,
        setHeaderInfo: setPageHeaderInfo,
    })

    // Загрузка объявлений/исполнителей у при изменении URL (включая монтирование).
    useEffect(
        () => loadItems('filter'),
        [location.key, adsPresentation]
    )

    const hasLocationInUrlQuery: boolean = (
        parseInt(urlQueryData.location ?? '0') > 0
    )

    const shouldLoadExecutorsFromAnotherLocations: boolean = (
        isAllItemsLoaded
        && totalItemsCount !== null
        && totalItemsCount < pageLimit
        && hasLocationInUrlQuery
    )

    return (
        <AsyncDataLoading
            loading={isLoading !== null && isLoading !== 'next'}
            className="flex-1"
            error={loadingError}
            onReload={() => loadItems('filter')}
            render={() => (
                <div>
                    <ServicesList
                        executors={items}
                        isAllExecutorsLoaded={isAllItemsLoaded}
                        onLoadMore={() => loadItems('next', false)}
                        disabled={isLoading == 'next'}
                        onExecutorDataChange={onItemDataChange}
                    />

                    {shouldLoadExecutorsFromAnotherLocations && (
                        <ServicesFromOtherLocations
                            categoryId={categoryId}
                            filters={urlQueryData}
                        />
                    )}
                </div>
            )}
        />
    )
}
